<ng-container screenAnalytics="mission-edit-v2-dialogue">
    <div class="modal-header">
        <div class="panel-heading-icon">
            <img imgPath="/icons/icon-missions.png" />
        </div>
        <h3 *ngIf="!isCreated" class="modal-title">
            {{ lockEditFields ? 'View' : savedMission?.id ? 'Edit' : 'Add' }}
            Mission Plan
        </h3>
        <h3 *ngIf="isCreated" class="modal-title">
            {{ savedMission?.name }}
        </h3>
        <enhanced-help-switch></enhanced-help-switch>
        <knowledge-base-link></knowledge-base-link>
        <button
            type="button"
            (click)="close()"
            aria-label="Close"
            class="close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form
        *ngIf="missionForm"
        [formGroup]="missionForm"
        (ngSubmit)="submit()"
        novalidate
    >
        <div class="modal-body mission inner-container-and-footer">
            <div
                class="modal-body-content container-with-navigation"
                [ngClass]="{ 'no-scroll': locked }"
                scrollSpy
                [spiedTags]="['DIV']"
                [spiedContainer]="content"
                (sectionChange)="onSectionChange($event)"
            >
                <!-- Menu left -->
                <div
                    class="container-menu vertical-container"
                    style="max-height: 100%; min-height: 100%"
                >
                    <div class="item">
                        <div class="indicator">
                            <span
                                *ngIf="isActive['objectives']"
                                class="fa fa-arrow-right"
                            ></span>
                        </div>
                        <button
                            type="button"
                            (click)="scrollTo('objectives')"
                            [class.disabled]="locked"
                        >
                            <i class="far fa-list-check tab-title-icon"></i>
                            Objectives
                        </button>
                    </div>

                    <div class="item">
                        <div class="indicator">
                            <span
                                *ngIf="isActive['planning']"
                                class="fa fa-arrow-right"
                            ></span>
                        </div>
                        <button
                            type="button"
                            (click)="scrollTo('planning')"
                            [class.disabled]="!isResourcesCompleted || locked"
                        >
                            <i class="far fa-ruler-combined tab-title-icon"></i>
                            Planning
                        </button>
                    </div>

                    <div class="item">
                        <div class="indicator">
                            <span
                                *ngIf="isActive['resources']"
                                class="fa fa-arrow-right"
                            ></span>
                        </div>
                        <button
                            type="button"
                            (click)="scrollTo('resources')"
                            [class.disabled]="
                                !missionObjectivesGroup.valid || locked
                            "
                        >
                            <i class="far fa-book-sparkles tab-title-icon"></i>
                            Resources
                        </button>
                    </div>

                    <div class="item">
                        <div class="indicator">
                            <span
                                *ngIf="isActive['documentation']"
                                class="fa fa-arrow-right"
                            ></span>
                        </div>
                        <button
                            type="button"
                            (click)="scrollTo('documentation')"
                            [class.disabled]="!isResourcesCompleted || locked"
                        >
                            <i class="far fa-file tab-title-icon"></i>
                            Documentation
                        </button>
                    </div>

                    <div
                        *ngIf="!useLegacyApprovals && hasSubmittedApprovals"
                        class="item"
                    >
                        <div class="indicator">
                            <span
                                *ngIf="isActive['approval']"
                                class="fa fa-arrow-right"
                            ></span>
                        </div>
                        <button
                            type="button"
                            (click)="scrollTo('approval')"
                            [class.disabled]="!isResourcesCompleted || locked"
                        >
                            <i class="far fa-file tab-title-icon"></i>
                            Approval
                        </button>
                    </div>

                    <div
                        *ngIf="
                            !canCheckAirspace &&
                            airspaceAuthorisationsEnabled &&
                            !missionObjectivesGroup.controls.isDummy.value &&
                            userCanViewAirspaceAuthorisation &&
                            !showInlineAuthorisation
                        "
                        class="item"
                    >
                        <div class="indicator">
                            <span
                                *ngIf="isActive['authorisation']"
                                class="fa fa-arrow-right"
                            ></span>
                        </div>
                        <airspace-authorisation-link
                            [canRequest]="
                                userCanRequestAirspaceAuthorisation &&
                                isResourcesCompleted &&
                                savedMission?.id != null &&
                                missionWorkflowVersionId.value != null &&
                                savedMission?.missionWorkflowVersionId ===
                                    missionWorkflowVersionId.value &&
                                !locked &&
                                airspaceAuthorisationsEnabled
                            "
                            [working]="working"
                            [disabled]="
                                missionObjectivesGroup.controls.isDummy.value
                            "
                            (linkClicked)="scrollTo('authorisation')"
                            (requestAuthorisation)="
                                latestAuthorisationStatus === 'CANCELLED'
                                    ? requestNewAirspaceAuthorisation()
                                    : showAirspaceAuthorisation()
                            "
                        ></airspace-authorisation-link>
                    </div>

                    <ng-container *ngIf="canCheckAirspace">
                        <airspace-check
                            #airspaceChecker
                            screenIdentifier="mission-edit-v2"
                        ></airspace-check>
                    </ng-container>
                </div>

                <!-- Content -->
                <div
                    #content
                    class="container-content form-horizontal"
                    tabindex="0"
                >
                    <div style="padding: 0 15px">
                        <enhanced-help
                            class="no-min-height"
                            screenName="enhanced-help-help"
                            componentName="main"
                        >
                        </enhanced-help>
                    </div>

                    <div id="objectives">
                        <div class="vertical-container container-fluid">
                            <h4
                                class="section-heading"
                                [ngClass]="{ readonly: working || locked }"
                            >
                                <span>MISSION OBJECTIVES </span>
                                <div></div>
                            </h4>

                            <ng-container
                                formGroupName="missionObjectivesGroup"
                            >
                                <div class="form-group input-content">
                                    <div class="col-xs-3 text-right">
                                        <label
                                            class="control-label"
                                            [ngClass]="{
                                                readonly: working || locked
                                            }"
                                        >
                                            Mission Name
                                            <field-validation-indicator
                                                validatorFormControlName="name"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <input
                                            type="text"
                                            placeholder="Type a name for your new mission"
                                            formControlName="name"
                                            class="form-control"
                                            minlength="3"
                                            (ngModelChange)="
                                                stepCompleted('missionName')
                                            "
                                            (focus)="setStep('missionName')"
                                            [readonly]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                        />
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>
                                <enhanced-help componentName="name">
                                </enhanced-help>

                                <ng-container
                                    *ngIf="
                                        canUseProjects &&
                                        (projects$ | async)?.length !== 0
                                    "
                                >
                                    <div class="form-group input-content">
                                        <div class="col-xs-3 text-right">
                                            <label
                                                class="control-label"
                                                [ngClass]="{
                                                    readonly: working || locked
                                                }"
                                            >
                                                Project
                                                <field-validation-indicator
                                                    validatorFormControlName="projectId"
                                                    noun="field"
                                                    placement="right"
                                                ></field-validation-indicator>
                                            </label>
                                        </div>
                                        <div class="col-xs-6">
                                            <ng-select
                                                name="project"
                                                formControlName="projectId"
                                                placeholder="Select"
                                                [items]="projects$ | async"
                                                [readonly]="
                                                    working ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                [clearable]="true"
                                                appendTo="body"
                                                bindLabel="name"
                                                bindValue="id"
                                            >
                                            </ng-select>
                                        </div>
                                        <div class="col-xs-3"></div>
                                    </div>
                                    <enhanced-help
                                        componentName="missionProject"
                                    >
                                    </enhanced-help>
                                </ng-container>

                                <ng-container
                                    *ngIf="
                                        canUseWorkgroup &&
                                        (workgroup$ | async)?.length !== 0
                                    "
                                >
                                    <div class="form-group input-content">
                                        <div class="col-xs-3 text-right">
                                            <label
                                                class="control-label"
                                                [ngClass]="{
                                                    readonly: working || locked
                                                }"
                                            >
                                                Workgroup
                                                <field-validation-indicator
                                                    validatorFormControlName="workgroup"
                                                    noun="field"
                                                    placement="right"
                                                ></field-validation-indicator>
                                            </label>
                                        </div>
                                        <div class="col-xs-6">
                                            <ng-select
                                                name="workgroup"
                                                formControlName="workgroup"
                                                placeholder="Select"
                                                [items]="workgroup$ | async"
                                                [readonly]="
                                                    working ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                [clearable]="true"
                                                appendTo="body"
                                                bindLabel="name"
                                            >
                                                <ng-template
                                                    ng-option-tmp
                                                    ng-label-tmp
                                                    let-item="item"
                                                    ><span
                                                        class="ng-option-label"
                                                        [title]="item.name"
                                                    >
                                                        {{ item.name }}</span
                                                    >
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="col-xs-3"></div>
                                    </div>
                                    <enhanced-help
                                        componentName="missionWorkgroup"
                                    >
                                    </enhanced-help>
                                </ng-container>

                                <div class="form-group input-content">
                                    <div class="col-xs-3 text-right">
                                        <label
                                            class="control-label"
                                            [ngClass]="{
                                                readonly: working || locked
                                            }"
                                            >Mission Classification
                                            <field-validation-indicator
                                                validatorFormControlName="isDummy"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <div
                                            class="input-group"
                                            btnRadioGroup
                                            formControlName="isDummy"
                                            style="padding-top: 7px"
                                        >
                                            <label
                                                class="btn btn-xs btn-pill"
                                                [btnRadio]="false"
                                                [disabled]="
                                                    working ||
                                                    lockedFields?.isDummy ||
                                                    locked ||
                                                    (missionEditService.isSelectDummyRpa$
                                                        | async) ||
                                                    (missionEditService.isSelectDummyEquipment$
                                                        | async) ||
                                                    lockEditFields
                                                "
                                                [tooltip]="
                                                    (missionEditService.isSelectDummyRpa$
                                                        | async) ||
                                                    (missionEditService.isSelectDummyEquipment$
                                                        | async)
                                                        ? 'Missions where dummy RPA or Equipment have been assigned cannot be converted to real missions.'
                                                        : null
                                                "
                                                placement="top"
                                                >Real Mission</label
                                            >
                                            <label
                                                class="btn btn-xs btn-pill"
                                                [btnRadio]="true"
                                                [disabled]="
                                                    working ||
                                                    lockedFields?.isDummy ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                >Dummy Mission</label
                                            >
                                        </div>
                                    </div>

                                    <div class="col-xs-3"></div>
                                </div>

                                <enhanced-help componentName="isDummy">
                                </enhanced-help>

                                <div
                                    class="form-group input-content"
                                    *ngIf="canUseObjectives"
                                >
                                    <div class="col-xs-3 text-right">
                                        <label
                                            class="control-label"
                                            [ngClass]="{
                                                readonly: working || locked
                                            }"
                                        >
                                            Mission Objective
                                            <field-validation-indicator
                                                validatorFormControlName="missionObjectiveTypeId"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <ng-select
                                            name="missionObjectiveTypeId"
                                            formControlName="missionObjectiveTypeId"
                                            bindValue="id"
                                            bindLabel="name"
                                            placeholder="Select a mission objective for classifying this mission"
                                            [items]="missionObjectives"
                                            [readonly]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                            [clearable]="true"
                                            appendTo="body"
                                        >
                                            <ng-template
                                                ng-option-tmp
                                                let-item="item"
                                                let-index="index"
                                            >
                                                {{ item.name }}
                                            </ng-template>
                                            <ng-template
                                                ng-label-tmp
                                                let-item="item"
                                                let-index="index"
                                            >
                                                {{ item.name }}
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>

                                <enhanced-help
                                    *ngIf="canUseObjectives"
                                    componentName="missionObjectiveTypeId"
                                >
                                </enhanced-help>

                                <div class="form-group input-content">
                                    <div class="col-xs-3 text-right">
                                        <label
                                            class="control-label"
                                            [ngClass]="{
                                                readonly: working || locked
                                            }"
                                            >Mission Objective Description
                                            <field-validation-indicator
                                                validatorFormControlName="missionObjective"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <textarea
                                            class="form-control"
                                            rows="10"
                                            formControlName="missionObjective"
                                            placeholder="A list of instructions or objectives for the mission..."
                                            [autofocus]="isCreated"
                                            (ngModelChange)="
                                                stepCompleted(
                                                    'missionObjective'
                                                )
                                            "
                                            (focus)="
                                                setStep('missionObjective')
                                            "
                                            [readonly]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                        >
                                        </textarea>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>

                                <enhanced-help componentName="missionObjective">
                                </enhanced-help>
                            </ng-container>
                        </div>
                    </div>

                    <div id="planning">
                        <div class="vertical-container container-fluid">
                            <h4
                                class="section-heading"
                                [ngClass]="{
                                    disabled: locked
                                }"
                            >
                                <span>MISSION PLANNING</span>
                                <div></div>
                            </h4>

                            <div class="form-group input-content">
                                <div class="col-xs-3 text-right">
                                    <label
                                        class="control-label"
                                        [ngClass]="{
                                            readonly: working || locked
                                        }"
                                    >
                                        Mission Location
                                        <field-validation-indicator
                                            validatorFormControlName="missionObjectivesGroup.location"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <mission-location-selection
                                        [locked]="locked || lockEditFields"
                                        [working]="working"
                                    ></mission-location-selection>
                                </div>
                                <div class="col-xs-3"></div>
                            </div>

                            <enhanced-help componentName="locationId">
                            </enhanced-help>

                            <div class="input-content">
                                <flyfreely-map
                                    #map
                                    airspaceCheckResult
                                    siteBoundaries
                                    externalMissions
                                    notices
                                    style="height: 500px"
                                    [organisationId]="organisation.id"
                                    [features]="locationFeatures$ | async"
                                    [showFeatureSelection]="true"
                                    [requireCtrlToZoom]="true"
                                    [startTime]="missionStartTime"
                                    [endTime]="missionEndTime"
                                    [mapData]="mapData$ | async"
                                    [ruleset]="returnMissionRuleset()"
                                    [enableLayerGroupsByDefault]="[
                                        'NOTAM',
                                        'LOTAM',
                                        'MISSIONS',
                                        'EXTERNAL_MISSIONS',
                                        'SITES'
                                    ]"
                                    [ignoreClicksOnFeatureGroups]="[2, 3, 4, 5]"
                                    (featuresLoaded)="
                                        map.zoomToAllFeatures(false)
                                    "
                                    (fullscreenRequested)="
                                        onFullscreenRequested()
                                    "
                                ></flyfreely-map>
                                <div>
                                    <span class="display-label">Centre: </span
                                    ><span
                                        [innerHtml]="
                                            (locationBearings?.locationCentre
                                                ?.coordinates)[1]
                                                | formatLatitude
                                        "
                                    ></span
                                    ><span [innerHtml]="',&nbsp;'"></span
                                    ><span
                                        [innerHtml]="
                                            (locationBearings?.locationCentre
                                                ?.coordinates)[0]
                                                | formatLongitude
                                        "
                                    ></span
                                    ><span [innerHtml]="'&nbsp;'"></span
                                    ><span class="display-label">Area: </span>
                                    {{
                                        locationBearings?.locationArea
                                            | number: '1.0-0'
                                    }}
                                    m<sup>2</sup>
                                </div>
                            </div>

                            <div
                                class="form-group input-content"
                                style="margin-bottom: 0"
                                [ngClass]="{
                                    disabled: locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label"
                                        >Time Zone
                                        <field-validation-indicator
                                            validatorFormControlName="timeZone"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator
                                    ></label>
                                </div>
                                <div class="col-xs-6 vcenter">
                                    <lockable
                                        [isLocked]="lockedFields?.timeZone"
                                        message="The timezone is set automatically from the location"
                                    >
                                        <ng-template unlockedMode>
                                            <ng-select
                                                *ngIf="timeZoneOffsets != null"
                                                name="timeZone"
                                                placeholder="Select the timezone the mission times are in"
                                                formControlName="timeZone"
                                                [items]="timeZones"
                                                [readonly]="
                                                    working ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                appendTo="body"
                                                [clearable]="false"
                                                style="width: 100%"
                                            >
                                                <ng-template
                                                    ng-label-tmp
                                                    ng-option-tmp
                                                    let-item="item"
                                                    let-index="index"
                                                >
                                                    {{ item }} (UTC
                                                    {{ timeZoneOffsets[item] }})
                                                </ng-template>
                                            </ng-select>
                                        </ng-template>
                                        <ng-template lockedMode
                                            ><span>{{
                                                location.timeZone
                                            }}</span></ng-template
                                        >
                                    </lockable>
                                </div>
                            </div>
                            <div
                                class="form-group input-content no-spacing"
                                [ngClass]="{
                                    disabled: locked
                                }"
                            >
                                <div class="col-xs-3 text-right"></div>

                                <div
                                    class="col-xs-6 vcenter"
                                    [ngClass]="{
                                        readonly: working || locked
                                    }"
                                >
                                    <div class="vertical-container fill">
                                        <div
                                            class="horizontal-container"
                                            *ngIf="sunriseSunset"
                                        >
                                            <div class="right-buffer">
                                                <label class="control-label"
                                                    >Current Time at Location:
                                                </label>
                                                <span style="padding-left: 5px">
                                                    {{ currentLocalTime }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <enhanced-help componentName="timeZone">
                            </enhanced-help>

                            <!--  -->
                            <div
                                class="form-group input-content"
                                style="margin-bottom: 0"
                                [ngClass]="{
                                    disabled: locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label"
                                        >Planned Time
                                        <field-validation-indicator
                                            validatorFormControlName="missionDate"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator
                                    ></label>
                                </div>

                                <div class="col-xs-3">
                                    <div class="input-group">
                                        <input
                                            class="form-control"
                                            type="text"
                                            required
                                            #datepicker="bsDatepicker"
                                            bsDatepicker
                                            formControlName="missionDate"
                                            (focus)="setStep('plannedDate')"
                                            (change)="
                                                stepCompleted('plannedDate')
                                            "
                                            [readonly]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                            [isDisabled]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                        />
                                        <span
                                            *ngIf="!working"
                                            class="input-group-addon btn-default"
                                            (click)="datepicker.toggle()"
                                            [attr.aria-expanded]="
                                                datepicker.isOpen
                                            "
                                        >
                                            <i
                                                class="glyphicon glyphicon-calendar"
                                            ></i>
                                        </span>
                                    </div>
                                </div>

                                <div
                                    class="col-xs-3"
                                    style="width: fit-content"
                                >
                                    <timepicker
                                        formControlName="missionDate"
                                        [hourStep]="1"
                                        [minuteStep]="1"
                                        [showMeridian]="false"
                                        [showSpinners]="false"
                                        (change)="stepCompleted('plannedTime')"
                                        (focus)="setStep('plannedTime')"
                                        [readonlyInput]="
                                            working || locked || lockEditFields
                                        "
                                    >
                                    </timepicker>
                                </div>

                                <div class="col-xs-3">
                                    <label class="control-label">UTC: </label>
                                    <span style="padding-left: 5px">
                                        {{ utc }}
                                    </span>
                                </div>
                            </div>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled: locked
                                }"
                            >
                                <div class="col-xs-3 text-right"></div>

                                <div
                                    class="col-xs-6 vcenter"
                                    [ngClass]="{
                                        readonly: working || locked
                                    }"
                                >
                                    <div class="vertical-container fill">
                                        <div
                                            class="horizontal-container top-buffer"
                                            *ngIf="sunriseSunset"
                                        >
                                            <table
                                                class="table table-bordered no-margin"
                                            >
                                                <tbody>
                                                    <tr>
                                                        <th>
                                                            Civil Twilight
                                                            Starts
                                                        </th>
                                                        <th>Sunrise</th>
                                                        <th>Sunset</th>
                                                        <th>
                                                            Civil Twilight Ends
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{
                                                                civilTwilightStart
                                                            }}
                                                        </td>
                                                        <td>{{ sunrise }}</td>
                                                        <td>{{ sunset }}</td>
                                                        <td>
                                                            {{
                                                                civilTwilightEnd
                                                            }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <span
                                            >Time is local 24 hour time in this
                                            timezone</span
                                        >
                                    </div>
                                </div>
                            </div>
                            <enhanced-help componentName="missionDate">
                            </enhanced-help>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled: locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label"
                                        >Estimated Duration
                                        <field-validation-indicator
                                            validatorFormControlName="missionEstimatedTime"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <duration
                                        formControlName="missionEstimatedTime"
                                        [readonly]="
                                            working || locked || lockEditFields
                                        "
                                        [showHour]="true"
                                        [showMinute]="true"
                                        [showSecond]="false"
                                        [clearable]="false"
                                    >
                                    </duration>
                                </div>
                            </div>

                            <enhanced-help componentName="missionEstimatedTime">
                            </enhanced-help>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled: locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label"
                                        >Time of Day
                                        <field-validation-indicator
                                            validatorFormControlName="timeOfDay"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <div
                                        class="input-group"
                                        btnRadioGroup
                                        formControlName="timeOfDay"
                                        style="padding-top: 7px"
                                        [ngClass]="{
                                            disabled: locked
                                        }"
                                    >
                                        <label
                                            class="btn btn-xs btn-pill"
                                            btnRadio="DAY"
                                            [disabled]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                            >Day</label
                                        >
                                        <label
                                            class="btn btn-xs btn-pill"
                                            btnRadio="NIGHT"
                                            [disabled]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                            >Night</label
                                        >
                                        <label
                                            class="btn btn-xs btn-pill"
                                            btnRadio="DAY_NIGHT"
                                            [disabled]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                            >Both</label
                                        >
                                    </div>
                                </div>

                                <div class="col-xs-3"></div>
                            </div>

                            <enhanced-help componentName="timeOfDay">
                            </enhanced-help>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled: locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label"
                                        >Visual Line of Sight
                                        <field-validation-indicator
                                            validatorFormControlName="visualLineOfSight"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <div
                                        class="input-group"
                                        btnRadioGroup
                                        formControlName="visualLineOfSight"
                                        style="padding-top: 7px"
                                        [ngClass]="{
                                            disabled: locked
                                        }"
                                    >
                                        <!-- FIXME: these are being temporarily disabled and forced to VLOS for LAANC.
                                    ultimately this needs to be driven by the jurisdiction, -->
                                        <label
                                            class="btn btn-xs btn-pill"
                                            btnRadio="VLOS"
                                            [disabled]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                            >VLOS</label
                                        >
                                        <label
                                            class="btn btn-xs btn-pill"
                                            btnRadio="EVLOS"
                                            [disabled]="
                                                working ||
                                                locked ||
                                                showInlineAuthorisation ||
                                                lockEditFields
                                            "
                                            >EVLOS</label
                                        >
                                        <label
                                            class="btn btn-xs btn-pill"
                                            btnRadio="BVLOS"
                                            [disabled]="
                                                working ||
                                                locked ||
                                                showInlineAuthorisation ||
                                                lockEditFields
                                            "
                                            >BVLOS</label
                                        >
                                    </div>
                                </div>

                                <div class="col-xs-3"></div>
                            </div>

                            <enhanced-help componentName="visualLineOfSight">
                            </enhanced-help>

                            <div
                                class="form-group input-content"
                                style="margin-bottom: 0"
                                [ngClass]="{
                                    disabled: locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label"
                                        >Planned Max Height
                                        <field-validation-indicator
                                            validatorFormControlName="maximumHeight"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <div class="input-group">
                                        <input
                                            name="maximumHeight"
                                            type="number"
                                            class="form-control"
                                            placeholder="The maximum flight height of the mission above ground level"
                                            min="0"
                                            step="1"
                                            formControlName="maximumHeight"
                                            (change)="
                                                stepCompleted('maxHeight')
                                            "
                                            [readonly]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                        />
                                        <span class="input-group-addon"
                                            >ft AGL</span
                                        >
                                    </div>
                                </div>

                                <div class="col-xs-3"></div>
                            </div>

                            <div class="form-group input-content">
                                <div class="col-xs-3 text-right"></div>

                                <div
                                    class="col-xs-6 vcenter"
                                    [ngClass]="{
                                        disabled: locked
                                    }"
                                >
                                    <span
                                        style="padding-top: 10px"
                                        *ngIf="maximumHeight.value"
                                    >
                                        {{
                                            maximumHeight.value / 3.281
                                                | number: '1.0-1'
                                        }}
                                        m AGL
                                    </span>
                                </div>
                            </div>

                            <enhanced-help componentName="maximumHeight">
                            </enhanced-help>
                        </div>
                        <div id="situational-awareness">
                            <h4 class="section-heading" [ngClass]="{}">
                                <span>SITUATIONAL AWARENESS</span>
                                <div></div>
                            </h4>

                            <ng-container
                                *ngIf="
                                    isUsingAerodromes &&
                                    location?.airspaceJurisdiction
                                        ?.hasAerodromeData
                                "
                            >
                                <div class="form-group">
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            <button
                                                type="button"
                                                class="btn-circle text-center"
                                                [disabled]="
                                                    working ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                (click)="showAerodromeSearch()"
                                            >
                                                <span class="fa fa-plus"></span>
                                            </button>
                                            Nearby Aerodromes
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <div class="horizontal-container">
                                            <ng-container
                                                formArrayName="aerodromesOfInterest"
                                            >
                                                <div
                                                    *ngFor="
                                                        let contact of aerodromesOfInterest.controls;
                                                        let i = index
                                                    "
                                                >
                                                    <div
                                                        class="horizontal-container"
                                                    >
                                                        <contact-pill
                                                            [formControlName]="
                                                                i
                                                            "
                                                            [clickable]="true"
                                                            (removeItem)="
                                                                removeAirport(i)
                                                            "
                                                            (click)="
                                                                showAerodromeSearch(
                                                                    i
                                                                )
                                                            "
                                                        ></contact-pill>
                                                        <div
                                                            class="vertical-align pill-container no-wrap"
                                                            *ngIf="
                                                                (locationBearings
                                                                    ?.aerodromes)[
                                                                    i
                                                                ] != null
                                                            "
                                                        >
                                                            <span
                                                                [innerHtml]="
                                                                    (locationBearings
                                                                        ?.aerodromes)[
                                                                        i
                                                                    ] | bearing
                                                                "
                                                            ></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                                <enhanced-help componentName="nearbyAerodromes">
                                </enhanced-help>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    canUseNotams &&
                                    location?.airspaceJurisdiction?.hasNotam
                                "
                            >
                                <div class="form-group">
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            <button
                                                type="button"
                                                class="btn-circle text-center"
                                                [disabled]="
                                                    working ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                (click)="showNotamSearch()"
                                            >
                                                <span class="fa fa-plus"></span>
                                            </button>
                                            Mission NOTAMs
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <div
                                            *ngIf="
                                                declareNoRelevantNotam.value ===
                                                true
                                            "
                                            class="top-buffer"
                                        >
                                            No relevant NOTAM for mission.&nbsp;
                                            <em
                                                *ngIf="
                                                    savedMission.noNotamDeclarationPerson !=
                                                    null
                                                "
                                            >
                                                (Declared by
                                                {{
                                                    savedMission.noNotamDeclarationPerson
                                                        | formatPerson
                                                }}
                                                on
                                                {{
                                                    savedMission.noNotamDeclarationTime
                                                        | formatDate
                                                }}
                                                )
                                            </em>
                                        </div>
                                        <div
                                            class="vertical-container"
                                            *ngIf="
                                                missionForm.controls.notams
                                                    .value.length > 0
                                            "
                                        >
                                            <!-- <ng-container
                                                    formArrayName="aerodromesOfInterest"
                                                > -->
                                            <div
                                                *ngFor="
                                                    let notam of missionForm
                                                        .controls.notams.value;
                                                    let i = index
                                                "
                                            >
                                                <div
                                                    class="horizontal-container"
                                                >
                                                    <notam-details
                                                        style="flex: 1"
                                                        [notam]="notam"
                                                        [listOnly]="true"
                                                        [viewNotamDetailModal]="
                                                            viewNotamDetailModal
                                                        "
                                                        (deleteNotam)="
                                                            removeSearchNotam(
                                                                notam
                                                            )
                                                        "
                                                    ></notam-details>

                                                    <div
                                                        style="
                                                            line-height: 37px;
                                                        "
                                                        class="no-wrap"
                                                        *ngIf="
                                                            (locationBearings
                                                                ?.notams)[i] !=
                                                            null
                                                        "
                                                    >
                                                        <span
                                                            [innerHtml]="
                                                                (locationBearings
                                                                    ?.notams)[i]
                                                                    | bearing
                                                            "
                                                        ></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- </ng-container> -->
                                        </div>
                                    </div>
                                </div>
                                <enhanced-help componentName="notams">
                                </enhanced-help>
                            </ng-container>

                            <ng-container
                                *ngIf="
                                    hasSites ||
                                    (savedMission != null &&
                                        savedMission.missionSiteList.length > 0)
                                "
                            >
                                <div class="form-group">
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            Attached Sites </label
                                        ><new-feature
                                            type="PREVIEW"
                                            name="Sites"
                                            description="Sites associated with this mission's flight area"
                                        ></new-feature>
                                    </div>
                                    <div class="col-xs-6">
                                        <div
                                            *ngIf="savedMission?.id == null"
                                            class="top-buffer"
                                        >
                                            Save mission to check for attached
                                            sites.&nbsp;
                                        </div>
                                        <div
                                            *ngIf="
                                                savedMission?.id != null &&
                                                savedMission.missionSiteList
                                                    .length === 0
                                            "
                                            class="top-buffer"
                                        >
                                            No sites attached to this
                                            mission.&nbsp;
                                        </div>
                                        <div
                                            class="vertical-container"
                                            *ngIf="
                                                savedMission?.id != null &&
                                                savedMission.missionSiteList
                                                    .length > 0
                                            "
                                        >
                                            <div
                                                *ngFor="
                                                    let item of savedMission.missionSiteList
                                                "
                                            >
                                                <span>{{
                                                    item.site.name
                                                }}</span>
                                                <span
                                                    *ngIf="
                                                        item.site.description
                                                    "
                                                    class="left-buffer text-muted"
                                                >
                                                    —
                                                    {{ item.site.description }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>
                            </ng-container>

                            <ng-container
                                *ngIf="
                                    canUseLotams ||
                                    missionForm.controls.lotams.value.length > 0
                                "
                            >
                                <div class="form-group">
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            Mission LOTAMs </label
                                        ><new-feature
                                            type="PREVIEW"
                                            name="LOTAM"
                                            description="Local flight hazard notices"
                                        ></new-feature>
                                    </div>
                                    <div class="col-xs-6">
                                        <div
                                            *ngIf="savedMission?.id == null"
                                            class="top-buffer"
                                        >
                                            Save mission to check for relevant
                                            LOTAM.&nbsp;
                                        </div>
                                        <div
                                            *ngIf="
                                                savedMission?.id != null &&
                                                missionForm.controls.lotams
                                                    .value.length === 0
                                            "
                                            class="top-buffer"
                                        >
                                            No relevant LOTAM for mission.&nbsp;
                                        </div>
                                        <div
                                            class="vertical-container"
                                            *ngIf="
                                                missionForm.controls.lotams
                                                    .value.length > 0
                                            "
                                        >
                                            <div
                                                *ngFor="
                                                    let item of missionForm
                                                        .controls.lotams.value;
                                                    let i = index;
                                                    let last = last
                                                "
                                            >
                                                <div
                                                    class="horizontal-container"
                                                >
                                                    <mission-lotam-summary
                                                        style="flex: 1"
                                                        [ngClass]="{
                                                            'bottom-buffer':
                                                                !last
                                                        }"
                                                        [lotam]="item.notice"
                                                        [status]="item.status"
                                                        [acknowledgementList]="
                                                            item.acknowledgementList
                                                        "
                                                        [missionId]="
                                                            savedMission.id
                                                        "
                                                        [missionLocation]="
                                                            location
                                                        "
                                                        [organisation]="
                                                            organisation
                                                        "
                                                        [missionCrewDetails]="
                                                            savedMission.missionCrewDetails
                                                        "
                                                        [locationBearing]="
                                                            locationBearings
                                                                ?.lotams?.[i]
                                                        "
                                                    >
                                                    </mission-lotam-summary>
                                                    <!-- <div
                                                        style="
                                                            line-height: 37px;
                                                        "
                                                        class="no-wrap"
                                                        *ngIf="
                                                            (locationBearings
                                                                ?.lotams)[i] !=
                                                            null
                                                        "
                                                    >
                                                        <span
                                                            [innerHtml]="
                                                                (locationBearings
                                                                    ?.lotams)[i]
                                                                    | bearing
                                                            "
                                                        ></span>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="hasBlockingLotams"
                                            class="alert alert-danger top-buffer"
                                        >
                                            There is a LOTAM over the operating
                                            area preventing this mission from
                                            proceeding
                                        </div>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>
                                <enhanced-help componentName="lotams">
                                </enhanced-help>
                            </ng-container>

                            <ng-container
                                *ngIf="
                                    savedMission?.missionOverlapList?.length > 0
                                "
                            >
                                <div class="form-group">
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            Conflicting Missions </label
                                        ><new-feature
                                            type="PREVIEW"
                                            name="Conflicting Missions"
                                            description="Other missions with overlapping boundaries on a shared site"
                                        ></new-feature>
                                    </div>
                                    <div class="col-xs-6">
                                        <div
                                            *ngIf="savedMission?.id == null"
                                            class="top-buffer"
                                        >
                                            Save mission to check for
                                            Conflicting missions.&nbsp;
                                        </div>
                                        <div
                                            *ngIf="
                                                savedMission?.id != null &&
                                                savedMission.missionOverlapList
                                                    .length === 0
                                            "
                                            class="top-buffer"
                                        >
                                            No Conflicting missions.&nbsp;
                                        </div>
                                        <div
                                            class="vertical-container"
                                            *ngIf="
                                                savedMission?.id != null &&
                                                savedMission.missionOverlapList
                                                    .length > 0
                                            "
                                        >
                                            <div
                                                *ngFor="
                                                    let item of savedMission.missionOverlapList
                                                "
                                            >
                                                <mission-overlap-summary
                                                    style="flex: 1"
                                                    [overlappingMission]="
                                                        item.overlappingMission
                                                    "
                                                    [acknowledgementList]="
                                                        item.acknowledgementList
                                                    "
                                                    [mission]="savedMission"
                                                    [organisationId]="
                                                        organisation.id
                                                    "
                                                    [locationFeatures]="
                                                        (locationFeatures$
                                                            | async) ?? []
                                                    "
                                                    [overlapStatus]="
                                                        item.status
                                                    "
                                                >
                                                </mission-overlap-summary>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div *ngIf="canCheckAirspace" id="authorisations">
                        <div class="vertical-container container-fluid">
                            <h4
                                class="section-heading"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <span>WARNINGS AND BLOCKS</span>
                                <div></div>
                            </h4>
                            <inline-airspace-warnings-and-blockers></inline-airspace-warnings-and-blockers>
                        </div>
                        <div
                            *ngIf="
                                airspaceAuthorisationsEnabled &&
                                !missionObjectivesGroup.controls.isDummy
                                    .value &&
                                showInlineAuthorisation
                            "
                            id="authorisation"
                            class="vertical-container container-fluid"
                        >
                            <h4
                                class="section-heading"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <span>AUTHORISATION</span>
                                <div></div>
                            </h4>
                            <div class="fill">
                                <inline-authorisation
                                    [areAuthorisationRequirementsComplete]="
                                        areAuthorisationRequirementsComplete
                                    "
                                    [missionWorking]="working"
                                    [missionTimeZone]="location.timeZone"
                                    [currentUserCanRequestAuthorisation]="
                                        userCanRequestAirspaceAuthorisation
                                    "
                                    [currentUserCanViewAuthorisation]="
                                        userCanViewAirspaceAuthorisation
                                    "
                                    (onShowAirspaceAuthorisation)="
                                        showAirspaceAuthorisation($event)
                                    "
                                >
                                </inline-authorisation>
                                <!-- <airspace-authorisation-status
                                            [checkingAuthorisation]="
                                                checkingAuthorisation
                                            "
                                            [enabledAuthorisationTypes]="
                                                enabledAuthorisationTypes
                                            "
                                            [areAuthorisationRequirementsComplete]="
                                                areAuthorisationRequirementsComplete
                                            "
                                            [approvedAirspaceAuthorisation]="
                                                latestAuthorisation
                                            "
                                            [jurisdiction]="
                                                location?.airspaceJurisdiction
                                            "
                                            [hasRuleset]="
                                                returnMissionRuleset() !=
                                                null
                                            "
                                            [disabled]="
                                                missionObjectivesGroup
                                                    .controls.isDummy
                                                    .value ||
                                                loadingWorkflow
                                            "
                                            [isDummy]="
                                                missionObjectivesGroup
                                                    .controls.isDummy
                                                    .value
                                            "
                                            (showAirspaceAuthorisation)="
                                                showAirspaceAuthorisation()
                                            "
                                            (cancelAirspaceAuthorisation)="
                                                cancelAirspaceAuthorisation()
                                            "
                                            (requestNewAirspaceAuthorisation)="
                                                requestNewAirspaceAuthorisation()
                                            "
                                        ></airspace-authorisation-status> -->
                            </div>
                        </div>
                    </div>

                    <div id="resources">
                        <div class="vertical-container container-fluid">
                            <h4
                                class="section-heading"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <span>MISSION RESOURCES</span>
                                <div></div>
                            </h4>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <!-- This first column gets some extra padding to align with the lockable in the second column. -->
                                <div
                                    class="col-xs-3 text-right"
                                    style="padding-top: 7.6px"
                                >
                                    <label class="control-label">
                                        Mission Type
                                        <field-validation-indicator
                                            validatorFormControlName="missionTypeId"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>

                                <div class="col-xs-6" style="height: 34px">
                                    <lockable
                                        [isLocked]="lockedFields?.missionType"
                                        message="This mission has been created for a specific purpose and can not be changed"
                                    >
                                        <ng-template lockedMode>
                                            {{ mission.missionType?.name }}
                                        </ng-template>
                                        <ng-template unlockedMode>
                                            <ng-select
                                                name="missionTypeId"
                                                formControlName="missionTypeId"
                                                bindValue="id"
                                                bindLabel="name"
                                                placeholder="Select the type of operation"
                                                [items]="missionTypes"
                                                [readonly]="
                                                    working ||
                                                    lockedFields?.missionType ||
                                                    !missionObjectivesGroup.valid ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                (focus)="setStep('missionType')"
                                                [clearable]="false"
                                                appendTo="body"
                                            >
                                                <ng-template
                                                    ng-option-tmp
                                                    let-item="item"
                                                    let-index="index"
                                                >
                                                    {{ item.name }}
                                                </ng-template>
                                                <ng-template
                                                    ng-label-tmp
                                                    let-item="item"
                                                    let-index="index"
                                                >
                                                    {{ item.name }}
                                                </ng-template>
                                            </ng-select>
                                        </ng-template>
                                    </lockable>
                                </div>

                                <div class="col-xs-3"></div>
                            </div>

                            <enhanced-help componentName="missionTypeId">
                            </enhanced-help>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label">
                                        Mission Workflow
                                        <field-validation-indicator
                                            validatorFormControlName="missionWorkflowVersionId"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                    <action-required
                                        class="control-label-action-required"
                                        *ngIf="
                                            missionWorkflowPrimaryAuthority !=
                                                null &&
                                            missionDetails.missionWorkflowVersion !=
                                                null &&
                                            missionDetails
                                                .missionWorkflowVersion
                                                .delegatedAuthority != null &&
                                            !authorityRegistersSetUp
                                        "
                                        [nonCritical]="true"
                                        buttonText="View Authority"
                                        (buttonClick)="
                                            showAuthorityDetails(
                                                missionDetails
                                                    ?.missionWorkflowVersion
                                                    ?.delegatedAuthority
                                            )
                                        "
                                    >
                                        {{ authorityRegistersActionMessage }}
                                    </action-required>
                                </div>
                                <div class="col-xs-6">
                                    <ng-select
                                        name="missionWorkflowVersion"
                                        placeholder="Select a mission workflow to use"
                                        formControlName="missionWorkflowVersionId"
                                        bindValue="id"
                                        bindLabel="workflowName"
                                        [items]="missionWorkflows"
                                        [readonly]="
                                            working ||
                                            !missionTypeId.value ||
                                            !missionObjectivesGroup.valid ||
                                            locked ||
                                            lockEditFields
                                        "
                                        (focus)="setStep('missionWorkflow')"
                                        [clearable]="false"
                                        appendTo="body"
                                        [groupBy]="
                                            hasJurisdiction
                                                ? 'jurisdiction'
                                                : ''
                                        "
                                    >
                                        <ng-template
                                            ng-option-tmp
                                            let-item="item"
                                            let-index="index"
                                        >
                                            <span
                                                [ngClass]="{
                                                    error: item.expired
                                                }"
                                            >
                                                {{ item.workflowName
                                                }}{{
                                                    item.expired
                                                        ? ' (expired)'
                                                        : ''
                                                }}
                                            </span>
                                        </ng-template>
                                        <ng-template
                                            ng-label-tmp
                                            let-item="item"
                                            let-index="index"
                                        >
                                            <span
                                                [ngClass]="{
                                                    error:
                                                        item.expired ||
                                                        item.authorityArchived
                                                }"
                                            >
                                                {{ item.workflowName
                                                }}{{
                                                    item.expired
                                                        ? ' (expired)'
                                                        : ''
                                                }}{{
                                                    item.authorityArchived
                                                        ? ' (archived)'
                                                        : ''
                                                }}
                                            </span>
                                        </ng-template>
                                    </ng-select>

                                    <div
                                        *ngIf="loadingWorkflow"
                                        class="alert alert-info top-buffer"
                                        role="alert"
                                    >
                                        Loading workflow...
                                    </div>
                                    <ng-container
                                        *ngIf="
                                            workflowSelectionValidity$
                                                | async as workflowSelectionValidity
                                        "
                                        [ngSwitch]="workflowSelectionValidity"
                                    >
                                        <div
                                            *ngSwitchCase="'MISSING'"
                                            class="alert alert-danger top-buffer"
                                            role="alert"
                                        >
                                            The mission workflow selected on the
                                            original mission ({{
                                                savedMission
                                                    .missionWorkflowVersion
                                                    ?.workflowName
                                            }}) is no longer available. You need
                                            to select a new workflow to
                                            continue.
                                        </div>
                                        <div
                                            *ngSwitchCase="'DIFFERENT_VERSION'"
                                            class="alert alert-info top-buffer"
                                            role="alert"
                                        >
                                            The active version has changed since
                                            the original mission was created, so
                                            some of the forms may have changed.
                                            Where possible the data will be
                                            migrated.
                                        </div>
                                    </ng-container>
                                    <div
                                        style="margin-top: 10px"
                                        *ngIf="showChangeWorkflow"
                                    >
                                        <p class="help-block">
                                            By changing workflow any existing
                                            approval requests and documentation
                                            will be cancelled
                                        </p>

                                        <button
                                            type="button"
                                            class="btn btn-default btn-sm"
                                            (click)="undoWorkflowChange()"
                                            [disabled]="
                                                working ||
                                                locked ||
                                                loadingWorkflow
                                            "
                                        >
                                            Undo
                                        </button>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            type="button"
                                            (click)="changeWorkflow()"
                                            [disabled]="
                                                working ||
                                                !missionTypeId.value ||
                                                !missionObjectivesGroup.valid ||
                                                locked ||
                                                lockEditFields
                                            "
                                        >
                                            Change Workflow
                                        </button>
                                    </div>
                                    <div
                                        style="margin-top: 10px"
                                        *ngIf="
                                            !showChangeWorkflow &&
                                            showConfirmWorkFlow
                                        "
                                    >
                                        <p class="help-block">
                                            This workflow requires an approval,
                                            but one hasn't been started. Start
                                            one now?
                                        </p>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            type="button"
                                            (click)="initiateWorkflow()"
                                            [disabled]="
                                                working ||
                                                !missionTypeId.value ||
                                                !missionObjectivesGroup.valid ||
                                                locked ||
                                                lockEditFields
                                            "
                                        >
                                            Confirm Workflow
                                        </button>
                                    </div>
                                    <div
                                        style="margin-top: 10px"
                                        *ngIf="
                                            showAcknowledgeWorkflow &&
                                            !showConfirmWorkFlow &&
                                            !showChangeWorkflow
                                        "
                                    >
                                        <p class="help-block">
                                            This workflow has been prefilled and
                                            needs to be acknowledged to become
                                            active. Alternatively you can select
                                            a different workflow
                                        </p>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            type="button"
                                            (click)="initiateWorkflow()"
                                            [disabled]="
                                                working ||
                                                !missionTypeId.value ||
                                                !missionObjectivesGroup.valid ||
                                                locked ||
                                                lockEditFields
                                            "
                                        >
                                            Acknowledge Workflow
                                        </button>
                                    </div>
                                </div>
                                <div class="col-xs-3">
                                    <mission-authority-details-panel
                                        *ngIf="!canUseAdditionalAuthorities"
                                        [workflow]="
                                            missionDetails?.missionWorkflowVersion
                                        "
                                        [missionWorkflowPrimaryAuthority]="
                                            missionWorkflowPrimaryAuthority
                                        "
                                        [additionalAuthorityIds]="
                                            missionForm.value
                                                .additionalAuthorityIds
                                        "
                                        [authorityIndicatorLookup]="
                                            authorityIndicatorLookup
                                        "
                                        [allAdditionalAuthoritiesLookup]="
                                            allAdditionalAuthoritiesLookup
                                        "
                                        [availableAuthorityLookup]="
                                            availableAuthorityLookup
                                        "
                                        [showAdditionalAuthorities]="
                                            hasActiveApprovals &&
                                            canUseAdditionalAuthorities
                                        "
                                        [setDisabled]="
                                            working || locked || lockEditFields
                                        "
                                        (requestShowAuthorityDetails)="
                                            showAuthorityDetails($event)
                                        "
                                    ></mission-authority-details-panel>
                                </div>
                            </div>
                            <enhanced-help
                                componentName="missionWorkflowVersionId"
                            >
                            </enhanced-help>

                            <div
                                *ngIf="canUseAdditionalAuthorities"
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label">
                                        Additional Authorities
                                        <field-validation-indicator
                                            validatorFormControlName="additionalAuthorityIds"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>

                                <div class="col-xs-6">
                                    <!--
                                        In read only mode the organisation's
                                        authorities are never fetched, so the
                                        authority lookups are empty. Display the
                                        authorities recorded on the mission
                                        itself instead.
                                    -->
                                    <ng-container *ngIf="lockEditFields">
                                        <div
                                            *ngFor="
                                                let authority of savedMission
                                                    ?.missionWorkflowVersion
                                                    ?.additionalAuthorities
                                            "
                                            class="horizontal-container"
                                        >
                                            <div class="fill">
                                                {{
                                                    authority | formatAuthority
                                                }}
                                                <span
                                                    *ngIf="
                                                        authorityIndicatorLookup &&
                                                        authorityIndicatorLookup[
                                                            authority.id
                                                        ]
                                                    "
                                                    class="circle-indicator"
                                                >
                                                    {{
                                                        authorityIndicatorLookup[
                                                            authority.id
                                                        ]
                                                    }}
                                                </span>
                                            </div>
                                            <span
                                                ><em
                                                    >&nbsp;-&nbsp;From
                                                    workflow</em
                                                ></span
                                            >
                                        </div>
                                        <div
                                            *ngFor="
                                                let authority of savedMission?.additionalAuthorities
                                            "
                                            class="horizontal-container"
                                        >
                                            <div class="fill">
                                                {{
                                                    authority | formatAuthority
                                                }}
                                                <span
                                                    *ngIf="
                                                        authorityIndicatorLookup &&
                                                        authorityIndicatorLookup[
                                                            authority.id
                                                        ]
                                                    "
                                                    class="circle-indicator"
                                                >
                                                    {{
                                                        authorityIndicatorLookup[
                                                            authority.id
                                                        ]
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="
                                            !lockEditFields &&
                                            availableAuthorityLookup != null
                                        "
                                    >
                                        <ng-container
                                            *ngFor="
                                                let additionalAuthorityId of missionDetails
                                                    ?.missionWorkflowVersion
                                                    ?.additionalAuthorityIds;
                                                let first = first
                                            "
                                        >
                                            <div class="horizontal-container">
                                                <div
                                                    *ngIf="
                                                        availableAuthorityLookup[
                                                            additionalAuthorityId
                                                        ] == null
                                                    "
                                                    class="fill"
                                                >
                                                    <span
                                                        class="status-block expired"
                                                        >Authority not
                                                        available</span
                                                    >
                                                </div>
                                                <div
                                                    *ngIf="
                                                        availableAuthorityLookup[
                                                            additionalAuthorityId
                                                        ] != null
                                                    "
                                                    class="fill"
                                                >
                                                    {{
                                                        availableAuthorityLookup[
                                                            additionalAuthorityId
                                                        ].name
                                                    }}
                                                    <span
                                                        *ngIf="
                                                            authorityIndicatorLookup &&
                                                            authorityIndicatorLookup[
                                                                additionalAuthorityId
                                                            ]
                                                        "
                                                        class="circle-indicator"
                                                    >
                                                        {{
                                                            authorityIndicatorLookup[
                                                                additionalAuthorityId
                                                            ]
                                                        }}
                                                    </span>
                                                </div>
                                                <span
                                                    ><em
                                                        >&nbsp;-&nbsp;From
                                                        workflow</em
                                                    ></span
                                                >
                                            </div>
                                        </ng-container>
                                        <ng-container
                                            *ngFor="
                                                let additionalAuthorityId of missionForm
                                                    .value
                                                    .additionalAuthorityIds;
                                                let first = first
                                            "
                                        >
                                            <div class="horizontal-container">
                                                <div
                                                    *ngIf="
                                                        availableAuthorityLookup[
                                                            additionalAuthorityId
                                                        ] == null
                                                    "
                                                    class="horizontal-container fill"
                                                >
                                                    <span
                                                        class="status-block expired"
                                                        >Authority not
                                                        available</span
                                                    >
                                                </div>
                                                <div
                                                    *ngIf="
                                                        availableAuthorityLookup[
                                                            additionalAuthorityId
                                                        ] != null
                                                    "
                                                    class="fill"
                                                >
                                                    {{
                                                        availableAuthorityLookup[
                                                            additionalAuthorityId
                                                        ].name
                                                    }}
                                                    <span
                                                        *ngIf="
                                                            authorityIndicatorLookup &&
                                                            authorityIndicatorLookup[
                                                                additionalAuthorityId
                                                            ]
                                                        "
                                                        class="circle-indicator"
                                                    >
                                                        {{
                                                            authorityIndicatorLookup[
                                                                additionalAuthorityId
                                                            ]
                                                        }}
                                                    </span>
                                                </div>
                                                <button
                                                    class="btn btn-tertiary btn-delete"
                                                    type="button"
                                                    (click)="
                                                        removeAdditionalAuthority(
                                                            additionalAuthorityId
                                                        )
                                                    "
                                                    [disabled]="
                                                        working ||
                                                        loadingWorkflow
                                                    "
                                                >
                                                    <span
                                                        class="fal fa-trash-alt"
                                                    ></span>
                                                </button>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                    <div class="input-group input-select-group">
                                        <ng-select
                                            [ngModelOptions]="{
                                                standalone: true
                                            }"
                                            [items]="
                                                availableAdditionalAuthorities
                                            "
                                            bindValue="id"
                                            [(ngModel)]="
                                                newAdditionalAuthorityId
                                            "
                                            placeholder="Select an additional authority"
                                            [disabled]="working"
                                            [groupBy]="
                                                hasJurisdiction
                                                    ? 'jurisdiction'
                                                    : ''
                                            "
                                            [readonly]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                        >
                                            <ng-template
                                                ng-option-tmp
                                                let-item="item"
                                                let-index="index"
                                            >
                                                <authority-list-item
                                                    [compact]="false"
                                                    [authority]="item.authority"
                                                    [organisationId]="
                                                        organisation.id
                                                    "
                                                ></authority-list-item>
                                            </ng-template>
                                            <ng-template
                                                ng-label-tmp
                                                let-item="item"
                                                let-index="index"
                                            >
                                                <authority-list-item
                                                    [compact]="true"
                                                    [authority]="item.authority"
                                                    [organisationId]="
                                                        organisation.id
                                                    "
                                                ></authority-list-item>
                                            </ng-template>
                                        </ng-select>
                                        <span class="input-group-btn">
                                            <button
                                                class="btn btn-primary"
                                                type="button"
                                                [disabled]="
                                                    newAdditionalAuthorityId ==
                                                        null ||
                                                    working ||
                                                    loadingWorkflow ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                (click)="
                                                    addAdditionalAuthority()
                                                "
                                            >
                                                Add
                                            </button>
                                        </span>
                                    </div>
                                    <div
                                        style="margin-top: 10px"
                                        *ngIf="
                                            additionalApprovalCreationRequired
                                        "
                                    >
                                        <p class="help-block">
                                            One or more approvals are required
                                            by additional authorities that
                                            haven't been started. Start them
                                            now?
                                        </p>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            type="button"
                                            (click)="
                                                createApprovals(savedMission)
                                            "
                                            [disabled]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                        >
                                            Start Approvals
                                        </button>
                                    </div>
                                </div>

                                <div class="col-xs-3">
                                    <mission-authority-details-panel
                                        [workflow]="
                                            missionDetails?.missionWorkflowVersion
                                        "
                                        [missionWorkflowPrimaryAuthority]="
                                            missionWorkflowPrimaryAuthority
                                        "
                                        [additionalAuthorityIds]="
                                            missionForm.value
                                                .additionalAuthorityIds
                                        "
                                        [authorityIndicatorLookup]="
                                            authorityIndicatorLookup
                                        "
                                        [allAdditionalAuthoritiesLookup]="
                                            allAdditionalAuthoritiesLookup
                                        "
                                        [availableAuthorityLookup]="
                                            availableAuthorityLookup
                                        "
                                        [showAdditionalAuthorities]="
                                            hasActiveApprovals &&
                                            canUseAdditionalAuthorities
                                        "
                                        [setDisabled]="working || locked"
                                        (requestShowAuthorityDetails)="
                                            showAuthorityDetails($event)
                                        "
                                    ></mission-authority-details-panel>
                                </div>
                            </div>
                            <enhanced-help
                                *ngIf="canUseAdditionalAuthorities"
                                componentName="additionalAuthorityIds"
                            >
                            </enhanced-help>

                            <ng-container formArrayName="craftIds">
                                <div
                                    class="form-group input-content"
                                    [ngClass]="{
                                        disabled:
                                            !missionObjectivesGroup.valid ||
                                            locked
                                    }"
                                >
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            <button
                                                type="button"
                                                class="btn-circle text-center"
                                                (click)="addRpa()"
                                                [disabled]="
                                                    working ||
                                                    !missionObjectivesGroup.valid ||
                                                    !canAddCraft ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                            >
                                                <span class="fa fa-plus"></span>
                                            </button>
                                            RPA

                                            <field-validation-indicator
                                                [control]="craftIds"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div
                                        class="col-xs-9"
                                        style="min-height: 34px"
                                    >
                                        <ng-container
                                            *ngIf="craftIds.controls.length"
                                        >
                                            <div
                                                class="static-table-container top-buffer"
                                            >
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                style="
                                                                    width: 25%;
                                                                "
                                                            ></th>
                                                            <th>Last Flight</th>
                                                            <th>
                                                                Serviceability
                                                                Sign-Off
                                                            </th>
                                                            <th>
                                                                Next Scheduled
                                                                Maintenance
                                                            </th>
                                                            <th>
                                                                Serviceability
                                                                Status
                                                            </th>
                                                            <th>
                                                                Authority
                                                                Register Status
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 5%;
                                                                "
                                                            ></th>
                                                        </tr>
                                                        <tr
                                                            *ngIf="
                                                                authorityIndicatorLookup !=
                                                                    null &&
                                                                ((primaryAuthorityRpaRegisterDisabled &&
                                                                    selectedAuthorityIds.length >
                                                                        0) ||
                                                                    selectedAuthorityIds.length >=
                                                                        2)
                                                            "
                                                        >
                                                            <th></th>
                                                            <th></th>
                                                            <th></th>
                                                            <th></th>
                                                            <th></th>
                                                            <th
                                                                *ngFor="
                                                                    let authorityId of selectedAuthorityIds
                                                                "
                                                            >
                                                                {{
                                                                    authorityIndicatorLookup[
                                                                        authorityId
                                                                    ]
                                                                }}
                                                            </th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container
                                                            *ngFor="
                                                                let craft of craftIds.controls;
                                                                let i = index;
                                                                let even = even
                                                            "
                                                        >
                                                            <tr
                                                                mission-rpa-select
                                                                [ngClass]="{
                                                                    'row-even':
                                                                        even
                                                                }"
                                                                [formControl]="
                                                                    craft
                                                                "
                                                                [index]="i"
                                                                [readonly]="
                                                                    working ||
                                                                    lockedFields?.aircraft ||
                                                                    !missionObjectivesGroup.valid ||
                                                                    locked ||
                                                                    lockEditFields
                                                                "
                                                                [disable]="
                                                                    !missionObjectivesGroup.valid ||
                                                                    locked ||
                                                                    lockEditFields
                                                                "
                                                                [isLoading]="
                                                                    loadingWorkflow
                                                                "
                                                                [setStep]="
                                                                    setStep
                                                                "
                                                                [missionDetails]="
                                                                    missionDetails
                                                                "
                                                                [workflow]="
                                                                    missionForm.get(
                                                                        'missionWorkflowVersionId'
                                                                    ).value
                                                                "
                                                                [orgId]="
                                                                    organisation.id
                                                                "
                                                                [canUseWorkgroup]="
                                                                    canUseWorkgroup
                                                                "
                                                                [workgroupFormControl]="
                                                                    missionObjectivesGroup
                                                                        .controls
                                                                        .workgroup
                                                                "
                                                                [selectedAuthorityIds]="
                                                                    selectedAuthorityIds
                                                                "
                                                                [authoritiesWithRpaRegistersEnabled]="
                                                                    authoritiesWithRpaRegistersEnabled
                                                                "
                                                                (showRpaDetails)="
                                                                    showRpaDetails(
                                                                        i
                                                                    )
                                                                "
                                                                (deleteRpa)="
                                                                    deleteRpa(i)
                                                                "
                                                            ></tr>
                                                        </ng-container>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                            <enhanced-help componentName="craftIds">
                            </enhanced-help>

                            <ng-container *ngIf="canUseEquipment">
                                <div
                                    class="form-group input-content"
                                    [ngClass]="{
                                        disabled:
                                            !missionObjectivesGroup.valid ||
                                            locked
                                    }"
                                >
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            <button
                                                type="button"
                                                class="btn-circle text-center"
                                                (click)="addEquipment()"
                                                [disabled]="
                                                    working ||
                                                    !missionObjectivesGroup.valid ||
                                                    !canAddEquipment ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                            >
                                                <span class="fa fa-plus"></span>
                                            </button>
                                            Equipment

                                            <field-validation-indicator
                                                [control]="equipmentIds"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div
                                        class="col-xs-9"
                                        style="min-height: 34px"
                                    >
                                        <ng-container
                                            *ngIf="equipmentIds.controls.length"
                                        >
                                            <div
                                                class="static-table-container top-buffer"
                                                [ngClass]="{
                                                    disabled:
                                                        !missionObjectivesGroup.valid ||
                                                        locked
                                                }"
                                            >
                                                <table class="table">
                                                    <thead>
                                                        <th
                                                            style="width: 25%"
                                                        ></th>
                                                        <th>Serial Number</th>
                                                        <th>Model</th>
                                                        <th>Equipmment Type</th>
                                                        <th>
                                                            Serviceability
                                                            Status
                                                        </th>
                                                        <th
                                                            style="width: 5%"
                                                        ></th>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container
                                                            *ngFor="
                                                                let equipment of equipmentIds.controls;
                                                                let i = index;
                                                                let even = even
                                                            "
                                                        >
                                                            <tr
                                                                mission-equipment-select
                                                                [ngClass]="{
                                                                    'row-even':
                                                                        even
                                                                }"
                                                                [formControl]="
                                                                    equipment
                                                                "
                                                                [index]="i"
                                                                [readonly]="
                                                                    working ||
                                                                    !missionObjectivesGroup.valid ||
                                                                    locked ||
                                                                    lockEditFields
                                                                "
                                                                [disable]="
                                                                    !missionObjectivesGroup.valid ||
                                                                    locked ||
                                                                    lockEditFields
                                                                "
                                                                [setStep]="
                                                                    setStep
                                                                "
                                                                (showEquipmentDetails)="
                                                                    showEquipmentDetails(
                                                                        i
                                                                    )
                                                                "
                                                                (deleteEquipment)="
                                                                    deleteEquipment(
                                                                        i
                                                                    )
                                                                "
                                                            ></tr>
                                                        </ng-container>
                                                    </tbody>
                                                </table>
                                                <!-- <ng-container
                                                *ngFor="
                                                    let equipment of equipmentIds.controls;
                                                    let i = index
                                                "
                                            >
                                                <mission-equipment-select
                                                    class="fill"
                                                    [formControl]="equipment"
                                                    [index]="i"
                                                    [readonly]="
                                                        working ||
                                                        !missionObjectivesGroup.valid ||
                                                        locked
                                                    "
                                                    [disable]="
                                                        !missionObjectivesGroup.valid ||
                                                        locked
                                                    "
                                                    [setStep]="setStep"
                                                    (showEquipmentDetails)="
                                                        showEquipmentDetails(i)
                                                    "
                                                    (deleteEquipment)="
                                                        deleteEquipment(i)
                                                    "
                                                ></mission-equipment-select>
                                            </ng-container> -->
                                            </div>
                                        </ng-container>
                                        <add-associated-resources
                                            *ngIf="hasRpaResourceAssociation"
                                        ></add-associated-resources>
                                    </div>
                                </div>
                                <enhanced-help componentName="equipmentIds">
                                </enhanced-help>
                            </ng-container>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label">
                                        <button
                                            type="button"
                                            class="btn-circle text-center"
                                            (click)="addCrew()"
                                            [disabled]="
                                                working ||
                                                lockedFields?.missionCrew ||
                                                !missionObjectivesGroup.valid ||
                                                locked ||
                                                lockEditFields
                                            "
                                        >
                                            <span class="fa fa-plus"></span>
                                        </button>
                                        Crew
                                        <field-validation-indicator
                                            [valid]="
                                                missionForm.controls.rpic
                                                    .valid &&
                                                missionForm.controls.missionCrew
                                                    .valid
                                            "
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>

                                <div class="col-xs-9" style="min-height: 34px">
                                    <!-- overflow: visible overrides the overflow-x: auto set by .static-table-container,
                                         which would otherwise force overflow-y to clip as well (per CSS spec),
                                         cutting off the action-required popover rendered inline by ngx-bootstrap. -->
                                    <div
                                        class="static-table-container top-buffer"
                                        style="overflow: visible"
                                        [ngClass]="{
                                            disabled:
                                                !missionObjectivesGroup.valid ||
                                                locked
                                        }"
                                    >
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th style="width: 35%">
                                                        Role
                                                    </th>
                                                    <th style="width: 35%">
                                                        Person
                                                    </th>
                                                    <th style="width: 20%">
                                                        Authority Register
                                                        Status
                                                    </th>
                                                    <th
                                                        *ngIf="
                                                            (!primaryAuthorityPilotRegisterDisabled &&
                                                                selectedAuthorityIds.length <=
                                                                    1) ||
                                                            selectedAuthorityIds.length ===
                                                                0
                                                        "
                                                        style="width: 5%"
                                                    ></th>
                                                </tr>
                                                <tr
                                                    *ngIf="
                                                        authorityIndicatorLookup !=
                                                            null &&
                                                        ((primaryAuthorityPilotRegisterDisabled &&
                                                            selectedAuthorityIds.length >
                                                                0) ||
                                                            selectedAuthorityIds.length >=
                                                                2)
                                                    "
                                                >
                                                    <th style="width: 35%"></th>
                                                    <th style="width: 35%"></th>
                                                    <th
                                                        *ngFor="
                                                            let authorityId of selectedAuthorityIds
                                                        "
                                                    >
                                                        {{
                                                            authorityIndicatorLookup[
                                                                authorityId
                                                            ]
                                                        }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    mission-rpic-select
                                                    [roles]="rpicRoles"
                                                    [formControl]="rpic"
                                                    [pilotRegisterDisabled]="
                                                        primaryAuthorityPilotRegisterDisabled
                                                    "
                                                    (deleteCrew)="deleteCrew(i)"
                                                    (toggleShowDetails)="
                                                        showRpicRegisterDetails =
                                                            !showRpicRegisterDetails
                                                    "
                                                    (showPersonDetails)="
                                                        showPersonDetails(
                                                            $event
                                                        )
                                                    "
                                                    [orgId]="organisation.id"
                                                    [readonly]="
                                                        working ||
                                                        lockedFields?.missionCrew ||
                                                        !missionObjectivesGroup.valid ||
                                                        locked ||
                                                        lockEditFields
                                                    "
                                                    [isLoading]="
                                                        loadingWorkflow
                                                    "
                                                ></tr>
                                                <tr
                                                    *ngIf="
                                                        showRpicRegisterDetails &&
                                                        craftIds.value.length >
                                                            0
                                                    "
                                                >
                                                    <td colspan="5">
                                                        <pilot-register-details
                                                            [pilotId]="
                                                                rpic.value
                                                                    ?.rpicId
                                                            "
                                                            [rowEven]="true"
                                                            [authorityIndicatorLookup]="
                                                                authorityIndicatorLookup
                                                            "
                                                            [primaryAuthorityPilotRegisterDisabled]="
                                                                primaryAuthorityPilotRegisterDisabled
                                                            "
                                                        ></pilot-register-details>
                                                    </td>
                                                </tr>
                                                <ng-container
                                                    formArrayName="missionCrew"
                                                >
                                                    <ng-container
                                                        *ngFor="
                                                            let crew of missionCrew.controls;
                                                            let i = index;
                                                            let even = even
                                                        "
                                                    >
                                                        <ng-container
                                                            *ngIf="{
                                                                show: false
                                                            } as showDetails"
                                                        >
                                                            <!-- Do the usual "even" row styling on odd rows due to the fixed rpic row above -->
                                                            <tr
                                                                [ngClass]="{
                                                                    'row-even':
                                                                        !even
                                                                }"
                                                                mission-pilot-role-v2
                                                                *ngIf="
                                                                    canEditMissionCrew
                                                                "
                                                                [formControl]="
                                                                    crew
                                                                "
                                                                [roles]="
                                                                    crewRoles
                                                                "
                                                                [pilotRegisterDisabled]="
                                                                    primaryAuthorityPilotRegisterDisabled
                                                                "
                                                                (deleteCrew)="
                                                                    deleteCrew(
                                                                        i
                                                                    )
                                                                "
                                                                (toggleShowDetails)="
                                                                    showDetails.show =
                                                                        !showDetails.show
                                                                "
                                                                (showPersonDetails)="
                                                                    showPersonDetails(
                                                                        $event
                                                                    )
                                                                "
                                                                [missionDetails]="
                                                                    savedMission
                                                                "
                                                                [orgId]="
                                                                    organisation.id
                                                                "
                                                                [readonly]="
                                                                    working ||
                                                                    lockedFields?.missionCrew ||
                                                                    !missionObjectivesGroup.valid ||
                                                                    locked ||
                                                                    lockEditFields
                                                                "
                                                                [isLoading]="
                                                                    loadingWorkflow
                                                                "
                                                            ></tr>
                                                            <tr
                                                                *ngIf="
                                                                    showDetails.show &&
                                                                    craftIds
                                                                        .value
                                                                        .length >
                                                                        0
                                                                "
                                                                [ngClass]="{
                                                                    'row-even':
                                                                        !even
                                                                }"
                                                            >
                                                                <td colspan="5">
                                                                    <pilot-register-details
                                                                        [pilotId]="
                                                                            crew
                                                                                .value
                                                                                .personId
                                                                        "
                                                                        [rowEven]="
                                                                            even
                                                                        "
                                                                    ></pilot-register-details>
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- <div class="col-xs-3"></div> -->
                            </div>
                            <enhanced-help componentName="missionCrew">
                            </enhanced-help>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label
                                        class="control-label"
                                        [ngClass]="{
                                            readonly: working || locked
                                        }"
                                    >
                                        Point of Contact
                                        <field-validation-indicator
                                            validatorFormControlName="pointOfContact"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <div class="input-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            formControlName="pointOfContact"
                                            maxlength="100"
                                            placeholder="Name of the point of contact for this mission"
                                            [readonly]="
                                                working ||
                                                !missionObjectivesGroup.valid ||
                                                locked ||
                                                lockEditFields
                                            "
                                        />
                                        <span class="input-group-btn">
                                            <button
                                                type="button"
                                                class="btn btn-default"
                                                [disabled]="
                                                    working ||
                                                    !missionObjectivesGroup.valid ||
                                                    locked ||
                                                    rpic.value?.rpicId ==
                                                        null ||
                                                    lockEditFields
                                                "
                                                (click)="
                                                    useRpicAsPointOfContact()
                                                "
                                                tooltip="Copy name and contact details from the selected RPIC"
                                                placement="top"
                                            >
                                                Use RPIC
                                            </button>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-3"></div>
                            </div>

                            <enhanced-help componentName="pointOfContact">
                            </enhanced-help>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label
                                        class="control-label"
                                        [ngClass]="{
                                            readonly: working || locked
                                        }"
                                    >
                                        Point of Contact Details
                                        <field-validation-indicator
                                            validatorFormControlName="pointOfContactInformation"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="pointOfContactInformation"
                                        maxlength="100"
                                        placeholder="Phone number or other contact information"
                                        [readonly]="
                                            working ||
                                            !missionObjectivesGroup.valid ||
                                            locked ||
                                            lockEditFields
                                        "
                                    />
                                </div>
                                <div class="col-xs-3"></div>
                            </div>

                            <enhanced-help
                                componentName="pointOfContactInformation"
                            >
                            </enhanced-help>

                            <div
                                class="form-group input-content"
                                [ngClass]="{
                                    disabled:
                                        !missionObjectivesGroup.valid || locked
                                }"
                            >
                                <div class="col-xs-3 text-right">
                                    <label class="control-label"
                                        >Crew Notes
                                        <field-validation-indicator
                                            validatorFormControlName="crewNotes"
                                            noun="field"
                                            placement="right"
                                        ></field-validation-indicator>
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <textarea
                                        class="form-control"
                                        name="crewNotes"
                                        rows="10"
                                        formControlName="crewNotes"
                                        placeholder="Additional information that the crew should be aware of, such as extra equipment required, etc..."
                                        (focus)="setStep('crewNotes')"
                                        [readonly]="
                                            working ||
                                            !missionObjectivesGroup.valid ||
                                            locked ||
                                            lockEditFields
                                        "
                                    >
                                    </textarea>
                                </div>

                                <div class="col-xs-3"></div>
                            </div>

                            <enhanced-help componentName="crewNotes">
                            </enhanced-help>

                            <ng-container *ngIf="mission.modelVersion === 1">
                                <div class="form-group input-content">
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            Contact Details
                                            <field-validation-indicator
                                                validatorFormControlName="emergencyContacts"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <textarea
                                            name="emergencyContacts"
                                            class="form-control"
                                            rows="5"
                                            formControlName="emergencyContacts"
                                            placeholder="The emergency contact details for this area"
                                            (change)="stepCompleted('contacts')"
                                            (focus)="setStep('contacts')"
                                            [readonly]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                        >
                                        </textarea>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>
                                <enhanced-help
                                    componentName="emergencyContacts"
                                >
                                </enhanced-help>

                                <div class="form-group input-content">
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            Radio Frequencies
                                            <field-validation-indicator
                                                validatorFormControlName="radioFrequencies"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <input
                                            name="radioFrequencies"
                                            type="text"
                                            class="form-control"
                                            formControlName="radioFrequencies"
                                            placeholder="The radio frequency the pilot needs to be on"
                                            (change)="
                                                stepCompleted('frequencies')
                                            "
                                            (focus)="setStep('frequencies')"
                                            [readonly]="
                                                working ||
                                                locked ||
                                                lockEditFields
                                            "
                                        />
                                    </div>

                                    <div class="col-xs-3"></div>
                                </div>

                                <enhanced-help componentName="radioFrequencies">
                                </enhanced-help>
                            </ng-container>

                            <ng-container *ngIf="mission.modelVersion !== 1">
                                <div
                                    class="form-group"
                                    [ngClass]="{
                                        disabled: locked && !isAddingContacts
                                    }"
                                >
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            <button
                                                type="button"
                                                class="btn-circle text-center"
                                                [disabled]="
                                                    working ||
                                                    isAddingContacts ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                (click)="
                                                    isAddingContacts =
                                                        !isAddingContacts
                                                "
                                            >
                                                <span class="fa fa-plus"></span>
                                            </button>
                                            Important Contacts
                                            <field-validation-indicator
                                                validatorFormControlName="missionEmergencyContacts"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <div
                                            class="horizontal-container"
                                            style="flex-wrap: wrap"
                                        >
                                            <contact-add
                                                *ngIf="isAddingContacts"
                                                scrollTo
                                                nameLabel="Contact Name"
                                                valueLabel="Number"
                                                subtypeLabel="Contact Type (optional)"
                                                [requireName]="true"
                                                [requireValue]="true"
                                                [requireSubtype]="false"
                                                [editName]="true"
                                                [editSubtype]="true"
                                                [editValue]="true"
                                                [readonly]="
                                                    working || lockEditFields
                                                "
                                                (add)="addContact($event)"
                                                (cancel)="
                                                    isAddingContacts =
                                                        !isAddingContacts
                                                "
                                            ></contact-add>
                                            <ng-container
                                                formArrayName="missionEmergencyContacts"
                                            >
                                                <div
                                                    *ngFor="
                                                        let contact of missionEmergencyContacts.controls;
                                                        let i = index
                                                    "
                                                >
                                                    <contact-pill
                                                        [formControlName]="i"
                                                        (removeItem)="
                                                            removeContact(i)
                                                        "
                                                        [disabled]="
                                                            locked ||
                                                            lockEditFields
                                                        "
                                                    ></contact-pill>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>
                                <enhanced-help
                                    componentName="missionEmergencyContacts"
                                >
                                </enhanced-help>

                                <div
                                    class="form-group"
                                    [ngClass]="{
                                        disabled: locked && !isAddingFrequencies
                                    }"
                                >
                                    <div class="col-xs-3 text-right">
                                        <label class="control-label">
                                            <button
                                                type="button"
                                                class="btn-circle text-center"
                                                [disabled]="
                                                    working ||
                                                    isAddingFrequencies ||
                                                    locked ||
                                                    lockEditFields
                                                "
                                                (click)="
                                                    isAddingFrequencies =
                                                        !isAddingFrequencies
                                                "
                                            >
                                                <span class="fa fa-plus"></span>
                                            </button>
                                            Radio Frequencies
                                            <field-validation-indicator
                                                validatorFormControlName="missionRadioFrequencies"
                                                noun="field"
                                                placement="right"
                                            ></field-validation-indicator>
                                        </label>
                                    </div>
                                    <div class="col-xs-6">
                                        <div
                                            class="horizontal-container"
                                            style="flex-wrap: wrap"
                                        >
                                            <contact-add
                                                *ngIf="isAddingFrequencies"
                                                scrollTo
                                                nameLabel="Frequency Name"
                                                subtypeLabel="Type eg. TWR"
                                                valueLabel="Frequency"
                                                [requireName]="true"
                                                [requireSubtype]="false"
                                                [requireValue]="true"
                                                [editName]="true"
                                                [editSubtype]="true"
                                                [editValue]="true"
                                                [readonly]="
                                                    working || lockEditFields
                                                "
                                                (add)="addFrequency($event)"
                                                (cancel)="
                                                    isAddingFrequencies =
                                                        !isAddingFrequencies
                                                "
                                            ></contact-add>
                                            <ng-container
                                                formArrayName="missionRadioFrequencies"
                                            >
                                                <div
                                                    *ngFor="
                                                        let frequency of missionRadioFrequencies.controls;
                                                        let j = index
                                                    "
                                                >
                                                    <contact-pill
                                                        [formControlName]="j"
                                                        (removeItem)="
                                                            removeFrequency(j)
                                                        "
                                                        [disabled]="
                                                            locked ||
                                                            lockEditFields
                                                        "
                                                    ></contact-pill>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>

                                    <div class="col-xs-3"></div>
                                </div>

                                <enhanced-help
                                    componentName="missionRadioFrequencies"
                                >
                                </enhanced-help>
                            </ng-container>
                        </div>
                    </div>

                    <div id="documentation">
                        <div class="vertical-container container-fluid">
                            <h4
                                class="section-heading"
                                [ngClass]="{
                                    disabled:
                                        !isResourcesCompleted ||
                                        savedMission?.id == null ||
                                        locked
                                }"
                            >
                                <span>DOCUMENTATION</span>
                                <div></div>
                                <div
                                    class="btn-group"
                                    dropdown
                                    [isDisabled]="
                                        !isResourcesCompleted ||
                                        savedMission?.id == null ||
                                        locked ||
                                        lockEditFields
                                    "
                                >
                                    <button
                                        dropdownToggle
                                        type="button"
                                        class="btn btn-link dropdown-toggle"
                                        aria-controls="dropdown-basic"
                                    >
                                        ...
                                    </button>
                                    <ul
                                        *dropdownMenu
                                        class="dropdown-menu dropdown-menu-right"
                                        role="menu"
                                        aria-labelledby="button-basic"
                                    >
                                        <li role="menuitem">
                                            <a
                                                class="dropdown-item"
                                                (click)="
                                                    showSelectPrefillMission()
                                                "
                                                >Prefill from other mission</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </h4>
                            <div
                                *ngIf="savedMission?.id == null"
                                class="alert alert-info"
                            >
                                Please save the mission plan to start adding
                                documentation and attachments.
                            </div>
                            <div
                                *ngIf="locked && isAddingContacts"
                                class="alert alert-info"
                            >
                                Please complete adding a contact above.
                            </div>
                            <div
                                *ngIf="locked && isAddingFrequencies"
                                class="alert alert-info"
                            >
                                Please complete adding a frequency above.
                            </div>
                            <mission-documentation
                                *ngIf="!locked"
                                formControlName="documentation"
                                [organisation]="organisation"
                                [documentationStorage]="documentationStorage"
                                [prefillErrors]="prefillErrors"
                                [missionApprovalList]="missionApprovals"
                                [missionWorkflowName]="
                                    missionDetails?.missionWorkflowVersion
                                        ?.workflowName
                                "
                                groupTitle="Mission Planning"
                                step="pre-submit"
                                [readonly]="
                                    working ||
                                    !isResourcesCompleted ||
                                    locked ||
                                    lockEditFields
                                "
                                [attachmentsHandler]="attachmentsHandler"
                            ></mission-documentation>

                            <enhanced-help
                                *ngIf="savedMission?.id && !locked"
                                componentName="documentation"
                            >
                            </enhanced-help>
                            <div
                                class="form-group input-content"
                                *ngIf="savedMission?.id && !locked"
                            >
                                <div class="col-xs-3 text-right">
                                    <label
                                        class="control-label"
                                        [ngClass]="{
                                            disabled: !isResourcesCompleted
                                        }"
                                        >Attached Documents
                                    </label>
                                </div>
                                <div class="col-xs-6">
                                    <attachment-list
                                        [attachmentsHandler]="
                                            attachmentsHandler
                                        "
                                        [allowUploads]="isResourcesCompleted"
                                        [allowDelete]="isResourcesCompleted"
                                        [allowEdit]="isResourcesCompleted"
                                        [parentPromiseTracker]="workTracker"
                                        [disabled]="disabled"
                                        [requirementId]="null"
                                        permissions
                                        (isEditing)="
                                            isEditingAttachments = $event
                                        "
                                    >
                                    </attachment-list>
                                </div>

                                <div class="col-xs-3"></div>
                            </div>

                            <enhanced-help
                                *ngIf="savedMission?.id && !locked"
                                componentName="attachedDocuments"
                            >
                            </enhanced-help>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            canViewAuthorisationsInCurrentMissionStatus &&
                            airspaceAuthorisationsEnabled &&
                            (userCanViewAirspaceAuthorisation ||
                                userCanRequestAirspaceAuthorisation) &&
                            !showInlineAuthorisation
                        "
                        id="authorisation"
                    >
                        <div class="vertical-container container-fluid">
                            <h4
                                class="section-heading"
                                [ngClass]="{
                                    disabled:
                                        !isResourcesCompleted ||
                                        savedMission?.id == null ||
                                        locked
                                }"
                            >
                                <span>AIRSPACE AUTHORISATION</span>
                                <div></div>
                            </h4>
                            <div class="fill">
                                <div class="col-xs-3"></div>
                                <div class="col-xs-9">
                                    <div
                                        style="max-width: 740px; height: 280px"
                                    >
                                        <airspace-authorisation-status
                                            [enabledAuthorisationTypes]="
                                                enabledAuthorisationTypes
                                            "
                                            [areAuthorisationRequirementsComplete]="
                                                areAuthorisationRequirementsComplete
                                            "
                                            [jurisdiction]="
                                                location?.airspaceJurisdiction
                                            "
                                            [hasRuleset]="
                                                returnMissionRuleset() != null
                                            "
                                            [disabled]="
                                                missionObjectivesGroup.controls
                                                    .isDummy.value ||
                                                loadingWorkflow
                                            "
                                            [isDummy]="
                                                missionObjectivesGroup.controls
                                                    .isDummy.value
                                            "
                                            [userCanViewAirspaceAuthorisation]="
                                                userCanViewAirspaceAuthorisation
                                            "
                                            [userCanRequestAirspaceAuthorisation]="
                                                userCanRequestAirspaceAuthorisation
                                            "
                                            (showAirspaceAuthorisation)="
                                                showAirspaceAuthorisation()
                                            "
                                            (cancelAirspaceAuthorisation)="
                                                cancelAirspaceAuthorisation(
                                                    $event
                                                )
                                            "
                                            (requestNewAirspaceAuthorisation)="
                                                requestNewAirspaceAuthorisation(
                                                    $event
                                                )
                                            "
                                        ></airspace-authorisation-status>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            !useLegacyApprovals &&
                            (hasSubmittedApprovals ||
                                (canSubmitApprovalsIndividually &&
                                    hasDraftApprovals))
                        "
                        id="approval"
                    >
                        <div class="vertical-container container-fluid">
                            <h4
                                class="section-heading"
                                [ngClass]="{
                                    disabled:
                                        !isResourcesCompleted ||
                                        savedMission?.id == null ||
                                        locked
                                }"
                            >
                                <span>MISSION APPROVAL</span>
                                <div></div>
                            </h4>
                            <div class="fill">
                                <ng-container
                                    *ngFor="
                                        let approval of activeApprovals;
                                        let i = index;
                                        let last = last;
                                        trackBy: trackApprovalById
                                    "
                                >
                                    <inline-mission-approval
                                        [organisation]="organisation"
                                        [mission]="savedMission"
                                        [approval]="approval"
                                        [approvalNumber]="i + 1"
                                        [readonly]="working || locked"
                                        [canSubmitIndividually]="
                                            canSubmitApprovalsIndividually
                                        "
                                        [submitBlockedReason]="
                                            approvalSubmitBlockedReason
                                        "
                                    ></inline-mission-approval>
                                    <h4 class="section-heading" *ngIf="!last">
                                        <span></span>
                                        <div></div>
                                    </h4>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <p
                *ngIf="lockEditFieldsReason != null"
                class="text-info"
                style="display: inline-block"
                [tooltip]="lockEditFieldsReason"
                placement="bottom"
            >
                Read Only
            </p>
            <p
                *ngIf="showConfirmWorkFlow"
                class="text-danger"
                style="display: inline-block"
            >
                Please confirm the workflow to continue
            </p>
            <p
                *ngIf="
                    !showConfirmWorkFlow && hasPrefilledDocumentationResponses
                "
                class="text-danger"
                style="display: inline-block"
            >
                Please Note: Unsaved cloned values for forms marked with
                "Continue" may be lost after closing this dialogue.
            </p>
            <button
                *ngIf="
                    combinedStatus === 'NEW' ||
                    combinedStatus === 'DRAFT' ||
                    combinedStatus === 'SUBMITTED'
                "
                class="btn btn-default"
                type="button"
                (click)="save()"
                [disabled]="
                    missionObjectivesGroup.controls.name.invalid ||
                    working ||
                    locked ||
                    missionForm.pristine ||
                    isEditingAttachments ||
                    lockEditFields
                "
            >
                {{
                    combinedStatus === 'NEW' || combinedStatus === 'DRAFT'
                        ? 'Save'
                        : 'Amend'
                }}
            </button>

            <button
                *ngIf="
                    combinedStatus === 'NEW' ||
                    combinedStatus === 'DRAFT' ||
                    combinedStatus === 'SUBMITTED'
                "
                class="btn btn-default"
                type="button"
                (click)="saveAndClose()"
                [disabled]="
                    missionObjectivesGroup.controls.name.invalid ||
                    working ||
                    locked ||
                    missionForm.pristine ||
                    isEditingAttachments ||
                    lockEditFields
                "
            >
                {{
                    combinedStatus === 'NEW' || combinedStatus === 'DRAFT'
                        ? 'Save'
                        : 'Amend'
                }}
                and Close
            </button>
            <button
                class="btn btn-primary relative"
                type="submit"
                [disabled]="
                    working ||
                    !isSubmittable ||
                    approvalCreationRequired ||
                    additionalApprovalCreationRequired ||
                    approvalSubmitBlockedReason != null ||
                    locked ||
                    isEditingAttachments ||
                    lockEditFields
                "
                *ngIf="submitOption !== 'NONE'"
            >
                {{ submitOption === 'SUBMIT' ? 'Submit for Approval' : 'Fly' }}
                <span
                    class="overlay"
                    [tooltip]="approvalSubmitBlockedReason"
                    placement="top"
                ></span>
            </button>
        </div>
    </form>
    <inline-modal [show]="isShowingSelectPrefillMission"
        ><select-mission
            *ngIf="isShowingSelectPrefillMission"
            [organisation]="organisation"
            (cancel)="hideSelectPrefillMission()"
            (done)="onPrefillFromMission($event)"
        ></select-mission
    ></inline-modal>
    <inline-modal [show]="isAddingAerodromes"
        ><aerodrome-search
            *ngIf="isAddingAerodromes"
            [existingAerodromes]="
                missionForm.controls.aerodromesOfInterest.value
            "
            [existingFrequencies]="
                missionForm.controls.missionRadioFrequencies.value
            "
            [existingContacts]="
                missionForm.controls.missionEmergencyContacts.value
            "
            [defaultAerodromeCode]="defaultAerodromeCode"
            [locationCentre]="locationBearings?.locationCentre"
            (close)="hideAerodromeSearch()"
            (addAerodrome)="addAerodrome($event)"
            (addFrequency)="addAerodromeFrequency($event)"
            (addContact)="addAerodromeContact($event)"
            (removeAerodrome)="removeSearchAirport($event)"
            (removeFrequency)="removeSearchFrequency($event)"
            (removeContact)="removeSearchContact($event)"
        ></aerodrome-search
    ></inline-modal>
    <inline-modal [show]="isAddingNotams"
        ><notam-search
            *ngIf="isAddingNotams && canUseNotams"
            [existingAerodromes]="
                missionForm.controls.aerodromesOfInterest.value
            "
            [existingNotams]="missionForm.controls.notams.value"
            [locationJurisdiction]="location?.airspaceJurisdiction"
            [missionId]="savedMission?.id"
            [hasAcknowledgedNoRelevantNotams]="declareNoRelevantNotam.value"
            (close)="hideNotamSearch()"
            (addNotam)="addAerodromeNotam($event)"
            (removeNotam)="removeSearchNotam($event)"
            (acknowledgeNoRelevantNotam)="acknowledgeNoRelevantNotam()"
            [location]="location"
        ></notam-search
    ></inline-modal>
    <inline-modal
        *ngIf="location?.airspaceJurisdiction"
        [show]="showAirspaceDisclaimer"
        [sizeSmall]="true"
        style="max-height: fit-content"
    >
        <airspace-disclaimer
            screenIdentifier="mission-edit-v2"
            [airspaceJurisdiction]="location.airspaceJurisdiction"
            (done)="onAirspaceDisclaimerAcknowledged()"
        ></airspace-disclaimer>
    </inline-modal>
    <inline-modal
        #viewNotamDetailModal
        [sizeSmall]="true"
        style="max-height: fit-content"
    >
    </inline-modal>
</ng-container>
